export default {
    LOGIN_URL: 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyAC1XKJ-58JF-eNSYoXg-owMUQsYmHHvcM',
    REGISTER_URL: 'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyAC1XKJ-58JF-eNSYoXg-owMUQsYmHHvcM'
}